import { reactive, computed } from 'vue'

export function useFavouriteVehicle(id, name, brand) {
  const vehicle = reactive({ id, name, brand })
  const user = useAuthUser()
  const localePath = useLocalePath()
  const router = useRouter()
  const gtm = useGtm()
  const $http = useHttp()

  const favouriteIds = useState('favourite-ids', () => [])
  const isFavourite = computed(() => favouriteIds.value.includes(vehicle.id))

  const saveToLocalStorage = () => {
    if (import.meta.client) {
      localStorage.setItem('favourites_list', JSON.stringify(favouriteIds.value))
    }
  }

  const loadFromLocalStorage = () => {
    if (import.meta.client) {
      const saved = localStorage.getItem('favourites_list')
      if (saved) {
        try {
          favouriteIds.value = JSON.parse(saved)
        } catch (e) {
          favouriteIds.value = []
        }
      }
    }
  }

  const clearFavourites = () => {
    favouriteIds.value = []
    if (import.meta.client) {
      localStorage.removeItem('favourites_list')
    }
  }

  const syncFavouritesFromServer = async () => {
    if (!user.value) return

    const { data, error } = await $http('api/vehicles/favourites/', { method: 'GET' })
    if (error) {
      console.error('Failed to sync favourites from server:', error)
      return
    }

    favouriteIds.value = data || []
    saveToLocalStorage()
  }

  const toggleFavourite = async () => {
    if (!user.value) {
      return router.push(localePath('/users/login'))
    }

    const method = isFavourite.value ? 'DELETE' : 'PATCH'
    const wasFavourite = isFavourite.value

    const { data, error } = await $http('api/vehicles/favourites/', {
      method,
      body: { vehicle_ids: [vehicle.id] }
    })

    if (error) {
      console.error('Failed to toggle favourite:', error)
      return
    }

    favouriteIds.value = data || []
    saveToLocalStorage()
    trackBasket(!wasFavourite)
  }

  const trackBasket = (added) => {
    if (!import.meta.client) return
    const item = {
      id: vehicle.id,
      name: vehicle.name,
      list_name: "Favourites List",
      brand: vehicle.brand,
      category: "Car Subscription",
      list_position: 1,
      quantity: 1,
    }
    gtm.trackEvent({
      event: added ? 'add_to_cart' : 'remove_from_cart',
      user_id: user.value?.id || null,
      items: [item]
    })
  }

  return {
    favouriteIds,
    isFavourite,
    syncFavouritesFromServer,
    loadFromLocalStorage,
    clearFavourites,
    toggleFavourite,
  }
}
